import countriesJson2025 from '@assets/json/countries-2025.json'
import countriesInfoJson from '@assets/json/countries-info.json'
import countriesTacJson from '@assets/json/countries-tac.json'
import countriesVersionsJson from '@assets/json/countries-versions.json'
import languagesJson from '@assets/json/languages.json'
import { CountryData } from '@models/Country'
import { CountryInfoData } from '@models/CountryInfo'
import { CountryTacData } from '@models/CountryTac'
import { LanguageData } from '@models/Language'
import { Version } from '@models/Version'

export const countriesTac: CountryTacData[] = countriesTacJson as unknown as CountryTacData[]
export const countriesInfo: CountryInfoData = countriesInfoJson as unknown as CountryInfoData
export const languages: LanguageData[] = languagesJson as LanguageData[]

export const defaultDataCountries: CountryData[] = countriesJson2025 as unknown as CountryData[]

const versions = () => {
  const countriesVersionJsonData = (countriesVersionsJson as Version[]).filter((version) => {
    // filter the countries version data based on validUntil
    if (version.validUntil === 'NEVER_EXPIRED') { return true }

    const now = new Date()
    const versionDate = new Date(version.validUntil)

    return now < versionDate
  })

  const countriesVersionsData = countriesVersionJsonData.map((countryOptionData) => {
    const filename = countryOptionData.file
    try {
      const jsonData = require(`@assets/json/${filename}`)
      countryOptionData.countries = jsonData
    } catch (error) {
      countryOptionData.countries = defaultDataCountries
      console.log(`failed parsing countries data ${filename}`)
    }
    return countryOptionData
  })

  return countriesVersionsData
}
export const dataVersions: Version[] = versions()
export const dataCountries: CountryData[] = dataVersions[0].countries
